import { render, staticRenderFns } from "./AuditFlowTable.vue?vue&type=template&id=67221eb6&"
import script from "./AuditFlowTable.vue?vue&type=script&lang=js&"
export * from "./AuditFlowTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditFlowTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports